/**
 *
 * This file is for basic atoms that don't have a need for more advanced
 * context.
 */
import { atom } from "jotai"

/**
 * Atom for controlling the visibility of the full-page modal.
 *
 * This is used, for example, for the "full-page subscribe modal". It allows
 * the modal to be dismissed elsewhere in the app.
 */
export const isFullPageModalOpenAtom = atom<boolean>(false)

/**
 * Atom for controlling the visibility of the regular (non-full page) subscribe modal.
 */
export const isSubscribeModalOpenAtom = atom<boolean>(false)

/**
 * Atom for controlling if the user just minted a new NFT.
 *
 * Used to persist state across refreshes in the NFT collect modal.
 */
export const userJustMintedAtom = atom<boolean | undefined>(undefined)
